import {
  CityResponse,
  CountryResponse,
  Discount,
  DiscountForm,
  FetchDiscountParams,
  ListData,
} from "@/types";
import axiosInstance from "./api";

export function createDiscountService(form: DiscountForm) {
  return axiosInstance
    .post("/discount", form)
    .then((response) => response.data);
}

export function fetchDiscountDetailService(id: string): Promise<Discount> {
  return axiosInstance.get(`/discount/${id}`).then((response) => response.data);
}

export function updateDiscountService(form: DiscountForm, id: string) {
  return axiosInstance
    .put(`/discount/${id}`, form)
    .then((response) => response.data);
}

export function fetchListDiscountService(
  params: FetchDiscountParams,
): Promise<ListData<Discount>> {
  return axiosInstance
    .get("/discount", { params })
    .then((response) => response.data);
}

export function deleteDiscountService(id: string) {
  return axiosInstance
    .delete(`/discount/${id}`)
    .then((response) => response.data);
}

export function activeDiscountService(id: string, active: boolean) {
  return axiosInstance
    .patch(`/discount/${id}/active`, { active })
    .then((response) => response.data);
}

export function listCountryDiscountService(): Promise<CountryResponse> {
  return axiosInstance
    .get("/common/countries")
    .then((response) => response.data);
}

export function listCityByCountryService(
  countryCode: string,
): Promise<CityResponse> {
  return axiosInstance
    .get(`/common/cities-by-country?countryCode=${countryCode}`)
    .then((response) => response.data);
}
